/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Factor } from './Factor';
import {
    FactorFromJSON,
    FactorFromJSONTyped,
    FactorToJSON,
} from './Factor';

/**
 * 
 * @export
 * @interface AuthnContextUpdateChallengeOptions
 */
export interface AuthnContextUpdateChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof AuthnContextUpdateChallengeOptions
     */
    target_org_id: string;
    /**
     * 
     * @type {Factor}
     * @memberof AuthnContextUpdateChallengeOptions
     */
    factor?: Factor;
}

/**
 * Check if a given object implements the AuthnContextUpdateChallengeOptions interface.
 */
export function instanceOfAuthnContextUpdateChallengeOptions(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "target_org_id" in value;

    return isInstance;
}

export function AuthnContextUpdateChallengeOptionsFromJSON(json: any): AuthnContextUpdateChallengeOptions {
    return AuthnContextUpdateChallengeOptionsFromJSONTyped(json, false);
}

export function AuthnContextUpdateChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthnContextUpdateChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'target_org_id': json['target_org_id'],
        'factor': !exists(json, 'factor') ? undefined : FactorFromJSON(json['factor']),
    };
}

export function AuthnContextUpdateChallengeOptionsToJSON(value?: AuthnContextUpdateChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'target_org_id': value.target_org_id,
        'factor': FactorToJSON(value.factor),
    };
}

